import axios from 'axios'
import * as types from '../mutation-types'

// state
export const state = {
  preguntas_abiertas: [],
  preguntas_cerradas: []
}

// mutations
export const mutations = {

  [types.SAVE_PREGUNTAS] (state, { preguntasAbiertas, preguntasCerradas }) {
    state.preguntas_abiertas = preguntasAbiertas
    state.preguntas_cerradas = preguntasCerradas
  }

}

// actions
export const actions = {

  async fetchQuestionST ({ commit }) {
    try {
      const { data } = await axios.get('/api/salatecnica/getAdminQuestions')
      commit(types.SAVE_PREGUNTAS, { preguntasAbiertas: data.abiertas, preguntasCerradas: data.cerradas })
    } catch (e) {
      console.log(e.response)
      // commit(types.FETCH_USER_FAILURE)
    }
  }

}

// getters
export const getters = {
  getPreguntasAbiertas: state => state.preguntas_abiertas,
  getPreguntasCerradas: state => state.preguntas_cerradas
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/salatecnica.js